export enum CatalogProductType {
  ELECTRICAL_CABINET = 'electrical_cabinet',
  SPINE_MODULE = 'spine_module',
  HEATER = 'heater',
  GENERATOR = 'generator'
}
